exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-bc3f20dc]{font-size:16px;font-weight:700}.group[data-v-bc3f20dc]{padding:.5rem 0}.group p[data-v-bc3f20dc]{margin:0;padding:0 .5rem}.group[data-v-bc3f20dc]>:first-child{margin-top:0}.group[data-v-bc3f20dc]>:last-child{margin-bottom:0}.hours-row[data-v-bc3f20dc]{display:flex;align-items:center;justify-content:space-between}.hours-row.today[data-v-bc3f20dc]{font-weight:700}", ""]);

// exports
